module.exports = __webpack_public_path__ + "img/no-ticket.c7752966.png";